/*
 * @prop --component-quickfact-color-text: The color the quickfact text
 * @prop --component-quickfact-color-text-active: The color the quickfact text in active state
 * @prop --component-quickfact-color-toggle-icon: The color the quickfact icon
 * @prop --component-quickfact-color-toggle-icon-active: The color the active quickfact icon
*/

:host {
  display: block;
  width: 100%;

  .content {
    display: none;
  }

  .container {
    display: flex;
    justify-content: space-between;
    height: 100%;
    padding-bottom: 20px;

    .content {
      --mobile-icon-size: 48px;

      display: grid;
      grid-template-columns: var(--mobile-icon-size) 1fr;
      column-gap: 12px;

      @include breakpoint($small) {
        display: flex;
        align-items: center;
        column-gap: unset;
      }

      ::slotted(*[slot='icon']) {
        width: var(--mobile-icon-size);
        height: var(--mobile-icon-size);
        margin-top: 4px;
        flex-shrink: 0;
      }

      .text {
        grid-column-start: span 2;
        display: flex;
        flex-direction: column;
        text-align: left;
        margin-right: 12px;
      }
    }

    .headline,
    .subline {
      word-break: break-all;
      color: var(
        --component-quickfact-color-text,
        var(--current-color-text, var(--skin-color-text, $ui-dark))
      );
      font-size: 16px;
      line-height: 24px;
    }

    .subline {
      word-break: break-word;

      @include breakpoint($medium) {
        text-align: center;
      }
    }

    .arrow {
      --component-icon-color: var(
        --component-quickfact-color-toggle-icon,
        var(--current-color-primary, var(--skin-color-primary, #{$ui-blue}))
      );

      height: 20px;
      width: 20px;
      margin-top: 4px;
      flex-shrink: 0;
      align-self: flex-start;
      transition:
        transform 100ms ease-in,
        color 100ms ease-in,
        -webkit-transform 100ms ease-in;

      &.active {
        --component-icon-color: var(
          --component-quickfact-color-toggle-icon-active,
          var(--skin-color-accent, #{$ui-green})
        );

        transform: rotate(180deg);
      }
    }

    &--has-icon {
      .content .text {
        grid-column-start: 2;
      }
    }

    &--has-content {
      cursor: pointer;

      .content .text .ui-richtext {
        color: var(
          --component-quickfact-color-text-active,
          var(--current-color-primary, var(--skin-color-primary, $ui-blue))
        );
      }
    }
  }

  @include breakpoint($small) {
    display: inline-block;
    padding-bottom: 12px;

    .container {
      flex-direction: column;
      align-items: center;
      margin-bottom: 0;
      padding-bottom: 0;

      .content {
        flex-direction: column;
        align-items: center;
        justify-content: initial;

        ::slotted(*[slot='icon']) {
          width: 90px;
          height: 90px;
          flex-shrink: 0;
          align-items: start;
        }

        .text {
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          word-break: break-all;
          margin-right: 0;
        }

        &--small {
          ::slotted(*[slot='icon']) {
            width: 55px;
            height: 55px;
          }
        }

        &--left {
          flex-direction: row;
          align-items: flex-start;
          align-self: flex-start;

          .text {
            align-items: initial;
            text-align: left;
          }

          .subline {
            text-align: left;
          }

          .headline {
            margin-bottom: 0;
          }

          ::slotted(*[slot='icon']) {
            margin: 16px 16px 0 0;
          }
        }
      }

      .headline {
        font-size: 40px;
        line-height: 1.2;
        margin-bottom: 8px;
        flex-direction: row;
        height: var(--headline-height);
      }

      .subline {
        font-size: 24px;
        line-height: 1.3;
        flex-direction: row;
      }

      .arrow {
        width: 40px;
        height: 40px;
        margin-top: 28px;
        align-self: center;
      }
    }
  }
}
